import _ from 'lodash'

export const MapMarker = {
  options (text) {
    return { element: createElement(text), offset: [0, -markerHeight / 2 + markerAnchorOffset] }
  },
  popupOptions () {
    return { closeButton: false, offset: [0, -markerHeight] }
  },
  popupHTML (title, message) {
    return `<b>${title || ''}</b><br />${message || ''}`
  },
  setPopupState (marker, state) {
    const popup = marker && marker.getPopup()
    if (popup && popup.isOpen() !== state) {
      marker.togglePopup()
    }
  }
}

export const Geo = {
  toLngLat (coordinates) {
    return coordinates && [coordinates.longitude, coordinates.latitude]
  },
  fromLngLat (coordinates) {
    return coordinates && { longitude: coordinates.lng, latitude: coordinates.lat }
  },
  toLngLatBounds (list) {
    if (!_.isEmpty(list)) {
      const latitudes = _.map(list, i => i.latitude)
      const longitudes = _.map(list, i => i.longitude)
      return [ [_.min(longitudes), _.min(latitudes)], [_.max(longitudes), _.max(latitudes)] ]
    }
  }
}

const svgNS = 'http://www.w3.org/2000/svg'
const svgPath = 'm 29.183858,19.201942 c -3.349005,10.660961 -14.212165,22.798056 -14.212165,22.798056 0,0 -10.8631608,-12.957169 -14.18402305,-22.77072 A 15.000167,14.569981 0 1 1 30,14.472849 c 0,1.640148 -0.28142,3.280296 -0.844287,4.756429 z'

const markerHeight = 47
const markerAnchorOffset = 5
const markerWidth = 30
const dotRadius = 7

function createSvgElement (parent, name, attributes) {
  const el = document.createElementNS(svgNS, name)
  _.each(attributes, (value, key) => key === 'style' ? applyStyle(value, el) : el.setAttribute(key, value))

  parent && parent.appendChild(el)
  return el
}

function applyStyle (style, element) {
  return _.each(style, (value, key) => { element.style[key] = value })
}

function pixels (value) {
  return `${value}px`
}

function shadow (parent, scale) {
  const props = ellipseProps(markerWidth / 2, markerHeight - markerAnchorOffset, 12 * scale, 5 * scale, {
    fill: '#000000',
    opacity: 0.07
  })
  createSvgElement(parent, 'ellipse', props)
}

function ellipseProps (cx, cy, rx, ry, style) {
  return { cx, cy, rx, ry, style }
}

function createElement (text) {
  const marker = document.createElement('div')
  marker.className = 'po-maps-marker'

  const svg = createSvgElement(marker, 'svg', {
    viewBox: `0 0 ${markerWidth} ${markerHeight}`,
    style: {
      width: pixels(markerWidth),
      height: pixels(markerHeight)
    }
  })

  _.each(_.times(5), scale => shadow(svg, 1 - scale / 5))

  createSvgElement(svg, 'path', {
    d: svgPath
  })
  if (text) {
    const textElement = document.createElement('div')
    textElement.innerText = text
    marker.appendChild(textElement)
  } else {
    const offset = markerWidth / 2
    const props = ellipseProps(offset, offset, dotRadius, dotRadius, { fill: '#ffffff' })
    createSvgElement(svg, 'ellipse', props)
  }
  return marker
}
